import { IPaginationResponse, IInstitutionNotification } from "../types";
import {
  IShareRangeAnalysisEvent,
  IShareRangeAnalysisEventParams,
  IShareRangeAnalysisEventsParams,
} from "./types";
import { rootApi } from "../rootApi";

export const shareRangeAnalysisEventApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    shareRangeAnalysisEvents: builder.query<
      IPaginationResponse<IShareRangeAnalysisEvent>,
      IShareRangeAnalysisEventsParams
    >({
      query: ({ limit, ordering, offset, tab, type, issuerId }) => ({
        url: `share-range-analysis-events/`,
        params: {
          limit,
          ordering,
          offset,
          tab,
          type: type || undefined,
          issuer_id: issuerId || undefined,
        },
      }),
      providesTags: ["shareRangeAnalysisEvents"],
    }),
    shareRangeAnalysisEvent: builder.query<
      IShareRangeAnalysisEvent,
      IShareRangeAnalysisEventParams
    >({
      query: ({ id }) => ({
        url: `share-range-analysis-events/${id}/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "shareRangeAnalysisEvents", id: arg.id },
      ],
    }),
    sendShareRangeAnalysisReport: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `share-range-analysis-events/${id}/send-report/`,
        method: "POST",
      }),
      invalidatesTags: (_result, _, arg) => [
        { type: "shareRangeAnalysisEvents", id: arg.id },
        { type: "institutionNotifications", id: arg.id },
      ],
    }),
    institutionNotifications: builder.query<
      IInstitutionNotification[],
      { eventId: string; type?: string }
    >({
      query: ({ eventId, type }) => ({
        url: `share-range-analysis-events/${eventId}/institution-notifications/`,
        params: {
          type: type || undefined,
        },
      }),
      providesTags: (_result, _, arg) => [
        { type: "institutionNotifications", id: arg.eventId },
      ],
    }),
  }),
});

export const {
  useShareRangeAnalysisEventQuery,
  useShareRangeAnalysisEventsQuery,
  useSendShareRangeAnalysisReportMutation,
  useInstitutionNotificationsQuery,
} = shareRangeAnalysisEventApis;
